module.exports = __webpack_public_path__ + "img/پرسی.42bc00b8.png";